// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorPicker_wrapper__VK1FT","button_container":"ColorPicker_button_container__uxjy-"};